<form [formGroup]="ibanBicForm" suxForm>
  <sux-form-element
    label="{{ 'kontoverbindungen.edit.iban.label' | translate }}"
    labelFor="iban"
    controlName="iban"
  >
    <input
      id="iban"
      formControlName="iban"
      class="form-control"
      type="text"
      placeholder="CH89 0023 0230 5758 1340 M"
      [imask]="ibanMask"
      required
    />
  </sux-form-element>
  <sux-form-element *ngIf="showBic" [label]="getBicLabel()" labelFor="bic" controlName="bic">
    <input
      id="bic"
      formControlName="bic"
      class="form-control"
      type="text"
      [imask]="bicMask"
      [readonly]="isBicReadonly"
    />
  </sux-form-element>
</form>
<sux-exception [exceptions]="exceptions"></sux-exception>
